import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithError from '../../../../components/with-error/WithError';
import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';

import scss from '../ProjectRequestForm.module.scss';

function CommonField({ name, label, isRequired, children }) {
  const { t } = useTranslation('projectRequest');

  return (
    <Field name={name}>
      {({ input, meta }) => (
        <WithLabel
          label={label}
          variant={LABEL_STYLES.COLUMN}
          isBold
          isRequired={isRequired}
          isTwoDots
          extraClassName={scss.commonField}>
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            {children({ input, meta })}
          </WithError>
        </WithLabel>
      )}
    </Field>
  );
}

export default CommonField;
